@layer reset, default, list, simple, wide, compact, hover, active, focus;

@layer reset {
  :host {
    display: block;

    .gcds-pagination ul {
      padding: 0;
      list-style: none;
    }
  }
}

@layer default {
  :host .gcds-pagination {
    container: component pagination / inline-size;

    li {
      a {
        color: var(--gcds-pagination-default-text);
        font: var(--gcds-pagination-font-desktop);
        border-radius: var(--gcds-pagination-border-radius);

        @media only screen and (width < 48em) {
          font: var(--gcds-pagination-font-mobile);
        }
      }
    }
  }
}

@layer list {
  :host .gcds-pagination {
    :is(.gcds-pagination-list, .gcds-pagination-list-mobile-prevnext) {
      display: flex;
      flex-direction: row;
      margin: 0;
      width: fit-content;

      li {
        margin: var(--gcds-pagination-listitem-margin);

        a,
        & > span.gcds-pagination-list-ellipses {
          height: 3rem;
          min-width: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;

          &.gcds-pagination-end-button,
          &.gcds-pagination-end-button-mobile {
            padding: var(--gcds-pagination-list-end-button-padding);
            width: auto;
            min-width: auto;
            height: auto;
            text-decoration: none;

            span {
              text-decoration: underline;
            }
          }
        }

        &.gcds-pagination-mobile-prevnext {
          display: none;
        }

        &.gcds-pagination-list-mobile-ellipses {
          display: none;
        }
      }
    }

    .gcds-pagination-list-mobile-prevnext {
      display: flex;
      margin: var(--gcds-pagination-mobile-list-prevnext-margin);
    }

    & > div {
      width: fit-content;
    }
  }
}

@layer simple {
  :host .gcds-pagination-simple {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    li {
      margin: var(--gcds-pagination-simple-listitem-margin);

      &:has(+ li) {
        margin-block-end: var(--gcds-pagination-simple-listitem-divider-margin);
        border-block-end: var(--gcds-pagination-simple-listitem-divider-border);
        padding: var(--gcds-pagination-simple-listitem-divider-padding);
      }

      a {
        display: grid;
        padding: var(--gcds-pagination-simple-padding);

        & > gcds-icon {
          grid-area: icon;
        }

        & > .gcds-pagination-simple-text {
          grid-area: text;
          margin: var(--gcds-pagination-simple-listitem-text-margin);
        }

        & > span {
          grid-area: label;
          font-weight: var(--gcds-pagination-simple-label-font-weight);
        }
      }
    }

    .gcds-pagination-simple-listitem a {
      text-decoration: none;

      .gcds-pagination-simple-text,
      span {
        text-decoration: underline;
      }
    }

    .gcds-pagination-simple-listitem a {
      grid-template-areas:
        'icon text'
        'icon label';
      grid-template-columns: 2rem 6fr;
    }
  }
}

@layer wide {
  /* List display: list */
  @container pagination (width > 44em) {
    :host .gcds-pagination-list-mobile-prevnext {
      display: none;
    }
  }
}

@layer compact {
  @container pagination (width <= 44em) {
    :host .gcds-pagination {
      :is(.gcds-pagination-list, .gcds-pagination-list-mobile-prevnext) li {
        a {
          border: var(--gcds-pagination-border-width) solid currentColor;
        }

        & > span.gcds-pagination-list-ellipses {
          min-width: auto;
        }

        &:has(> a.gcds-pagination-end-button) {
          margin: 0;
        }

        .gcds-pagination-end-button {
          display: none;
        }

        &.gcds-pagination-mobile-prevnext {
          display: block;
        }
      }
    }
  }

  @container pagination (width <= 30em) {
    :host .gcds-pagination-list .gcds-pagination-list-breakpoint-sm {
      display: none;
    }
  }

  @container pagination (width <= 27.5em) {
    :host .gcds-pagination-list .gcds-pagination-list-breakpoint-xs {
      display: none;
    }
  }

  @container pagination (width <= 25em) {
    :host .gcds-pagination-list .gcds-pagination-list-breakpoint-xxs {
      display: none;
    }
  }

  @container pagination (width <= 19em) {
    :host .gcds-pagination-list li {
      margin: var(--gcds-pagination-mobile-list-item-margin);
    }
  }
}

@layer hover {
  @media (hover: hover) {
    :host .gcds-pagination ul li a:hover {
      background: var(--gcds-pagination-hover-background);
      color: var(--gcds-pagination-hover-text);
    }
  }
}

@layer active {
  :host .gcds-pagination ul li a {
    &:active:not(:focus),
    &[aria-current*='page']:not(:focus) {
      color: var(--gcds-pagination-active-text);
      background: var(--gcds-pagination-active-background);
      border-color: var(--gcds-pagination-active-background);
      text-decoration: none;
    }
  }
}

@layer focus {
  :host .gcds-pagination ul li a:focus {
    color: var(--gcds-pagination-focus-text);
    background-color: var(--gcds-pagination-focus-background);
    outline: var(--gcds-pagination-focus-outline-width) solid
      var(--gcds-pagination-focus-background);
    outline-offset: var(--gcds-pagination-border-width);
    box-shadow: var(--gcds-pagination-focus-box-shadow);
    text-decoration: none;
    border-color: var(--gcds-pagination-focus-background);
  }
}
